import { NoPageFoundComponent } from './no-page-found/no-page-found.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
const routes: Routes = [
    {
      path: '', component: NoPageFoundComponent,  data: { activeClass: 'register',title:"No Page Found - Provider Portal" }
    
    }
  ];
  
  export const NotFoundRoutingModule: ModuleWithProviders = RouterModule.forChild(routes);